import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-notification-popup',
  imports: [CommonModule],
  templateUrl: './notification-popup.html',
  styleUrl: './notification-popup.css',
})
export class NotificationPopup {
  @Input() data: any;
  @Input() loading = false;
  @Input() errorMessage = '';
  @Input() selectedAction = '';
  @Output() action = new EventEmitter<string>();
}